import React from 'react'

import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon'

interface Props extends SvgIconProps {
  filled?: boolean
}

const pathOutlined =
  'M7.925.746c.127-.135.252-.274.378-.417h-.754c.125.143.25.282.376.417zm7.408 3.038c.207-.035.' +
  '415-.08.624-.133l-.624-.484v.617zM.5 3.782v-.615l-.622.484c.208.053.415.097.622.131zm0 0c2.6' +
  '4.442 5.127-.585 7.425-3.036 2.294 2.456 4.776 3.484 7.408 3.038v8.615a3.5 3.5 0 0 1-1.829 3' +
  '.075L9.7 17.542a3.5 3.5 0 0 1-3.295.025l-4.029-2.11a3.5 3.5 0 0 1-1.876-3.1V3.782z'

const pathFilled =
  'M29.5 13.782v8.575a3.5 3.5 0 0 0 1.876 3.1l4.03 2.11a3.5 3.5 0 0 0 3.294-.025l3.804-2.068a3.' +
  '5 3.5 0 0 0 1.83-3.075v-8.615c-2.633.446-5.115-.582-7.409-3.038-2.298 2.45-4.786 3.478-7.425 3.036z'

const pathDef =
  'M29 13.167c2.819.71 5.461-.345 7.926-3.167 2.46 2.83 5.096 3.885 7.907 3.167v9.232a4 4 0 0 1' +
  '-2.09 3.515L38.94 27.98a4 4 0 0 1-3.766.03l-4.028-2.11A4 4 0 0 1 29 22.357v-9.19z'

const ShieldIcon: React.SFC<Props> = ({ filled, ...props }) => (
  <SvgIcon {...props} viewBox="-2 -2 20 23">
    <defs>
      <path d={pathDef} id="ShieldIcon-PathDef" />
    </defs>

    {filled && (
      <g transform="translate(-29 -10)" fill="none" fillRule="evenodd">
        <use fill="currentColor" xlinkHref="#ShieldIcon-PathDef"/>
        <path d={pathFilled} />
      </g>
    )}

    {!filled && <path d={pathOutlined} fill="none" stroke="currentColor" />}
  </SvgIcon>
)

export default ShieldIcon
